import { consolidationsQueryKey } from '../queries/consolidations';
import { createMutation } from '../utils/mutations';
import { deleteConsolidation } from '../../organisations/src/core/api/consolidation/consolidation';
import { queryClient } from '../core/queryClient';
import { updateWorkspace } from '../../skeleton/src/workspaces/api';
import { workspacesListingQueryKey } from '../operations/workspaces/queries/workspacesListingQuery';

interface DeleteConsolidationInput {
  consolidationId: string;
  workspaceId: string;
}

interface UpdateWorkspaceInput {
  data: Partial<{ name: string | null; is_default_workspace: boolean }>;
  workspaceId: string;
}

type DeleteConsolidationResult = Awaited<ReturnType<typeof deleteConsolidation>>;
type UpdateWorkspaceResult = Awaited<ReturnType<typeof updateWorkspace>>;

export const deleteConsolidationMutation = () =>
  createMutation<DeleteConsolidationInput, DeleteConsolidationResult>({
    mutationFn: ({ consolidationId, workspaceId }) => deleteConsolidation(workspaceId, consolidationId),
    onSuccess: (_data, { workspaceId }) => {
      queryClient.invalidateQueries({ queryKey: consolidationsQueryKey(workspaceId) });
    }
  });

export const updateWorkspaceMutation = () =>
  createMutation<UpdateWorkspaceInput, UpdateWorkspaceResult>({
    mutationFn: ({ workspaceId, data }) => updateWorkspace(workspaceId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: workspacesListingQueryKey() });
    }
  });
